import styled from 'styled-components';

export const StyledTbmStatusDashboardTable = styled.div`
  width: 220px;
`;

export const StyledTbmStatusTableTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  font-size: 16px;
  font-weight: 500;

  > div:first-child {
    align-content: center;
    text-align: center;
    flex: 1;
    background: #306cd2;
    color: #fff;
    border-bottom: 1px solid #dadada;
    border-top-left-radius: 12px;
    padding: 12px 0px;
  }

  > div:last-child {
    align-content: center;
    text-align: center;
    flex: 1;
    background: #adadad;
    color: #fff;
    border-bottom: 1px solid #dadada;
    border-top-right-radius: 12px;
  }
`;

export const StyledTbmStatusTableBody = styled.div`
  display: flex;
  flex-direction: column;

  gap: 0px;
  border: 1px solid #dadada;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  padding: 8px;
`;
